import React, { PropTypes } from 'react'
import { Link } from 'react-router'

const MobileNavBarBackButton = ({ goBack }) => (
  <Link onClick={goBack}>
    <span className='icon-arrow-back' />
  </Link>
)

MobileNavBarBackButton.displayName = 'MobileNavBarBackButton'
MobileNavBarBackButton.propTypes = {
  goBack: PropTypes.func.isRequired
}

export default MobileNavBarBackButton



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/MobileNavBarBackButton/MobileNavBarBackButton.js